import React, { createContext, useContext, useState, ReactNode } from 'react';

interface BookingModalContextType {
    isOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
}

const BookingModalContext = createContext<BookingModalContextType | undefined>(undefined);

export const useBookingModal = (): BookingModalContextType => {
    const context = useContext(BookingModalContext);
    if (!context) {
        throw new Error('useBookingModal must be used within a BookingModalProvider');
    }
    return context;
};

interface BookingModalProviderProps {
    children: ReactNode;
}

export const BookingModalProvider: React.FC<BookingModalProviderProps> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    return (
        <BookingModalContext.Provider value={{ isOpen, openModal, closeModal }}>
            {children}
        </BookingModalContext.Provider>
    );
};
